import { Controller } from "@hotwired/stimulus"
import { morphdomIgnore } from "web-ui/morphdom/ignore"
import * as Log from "web-ui/log"

// Connects to data-controller="character-counter"
export default class extends Controller {
  static targets = ["counter"]

  static values = {
    maximum: Number,
    inputId: String
  }

  connect() {
    this.debug("Connect", { maximum: this.maximumValue, inputId: this.inputIdValue })

    const input = this.input()
    input.addEventListener("input", this.update)

    this.observer = new MutationObserver(this.update)
    this.observer.observe(input, {
      attributes: true,
      attributeFilter: ["value"],
      characterData: true,
      childList: true,
      subtree: true
    })

    morphdomIgnore(this.counterTarget, true)

    this.update()
  }

  disconnect() {
    this.debug("Disconnect")

    const input = this.input()
    if (input !== null) {
      input.removeEventListener("input", this.update)
    }

    morphdomIgnore(this.counterTarget, false)
  }

  update = () => {
    const input = this.input()
    const count = input.value.length

    this.counterTarget.textContent = `${count}/${this.maximumValue}`
    this.counterTarget.classList.toggle("exceeds-maximum", count > this.maximumValue)
  }

  input() {
    return document.getElementById(this.inputIdValue)
  }

  debug(message, data) {
    Log.debug("Character Counter - " + message, data)
  }
}
